export default {
  name: 'Nome',
  tel: 'telefone',
  save: 'Salve ',
  confirm: 'confirme',
  cancel: 'cancelar',
  delete: 'excluir',
  complete: 'levar a cabo',
  loading: 'Carregando...',
  telEmpty: 'Por favor preencha o telefone',
  nameEmpty: 'Por favor, preencha seu nome',
  nameInvalid: 'Por favor insira o nome correto',
  confirmDelete: 'Tem certeza que deseja deletar',
  telInvalid: 'Por favor insira um número de telefone válido',
  vanCalendar: {
    end: 'o fim',
    start: 'começar',
    title: 'Seleção de data',
    confirm: 'determinar',
    startEnd: 'inicio fim',
    weekdays: ['Dia', 'um', 'dois', 'três', 'quatro', 'cinco', 'seis'],
    monthTitle: function monthTitle(year, month) {
      return year + "\u5E74" + month + "\u6708";
    },
    rangePrompt: function rangePrompt(maxRange) {
      return "\u9009\u62E9\u5929\u6570\u4E0D\u80FD\u8D85\u8FC7 " + maxRange + " \u5929";
    }
  },
  vanCascader: {
    select: 'por favor escolha'
  },
  vanContactCard: {
    addText: 'Adicionar contatos'
  },
  vanContactList: {
    addText: 'Novo contato'
  },
  vanPagination: {
    prev: 'Página anterior',
    next: 'Próxima página'
  },
  vanPullRefresh: {
    pulling: 'Puxe para baixo para atualizar...',
    loosing: 'Solte para atualizar...'
  },
  vanSubmitBar: {
    label: 'total：'
  },
  vanCoupon: {
    unlimited: 'Sem limite de uso',
    discount: function discount(_discount) {
      return _discount + "\u6298";
    },
    condition: function condition(_condition) {
      return "\u6EE1" + _condition + "\u5143\u53EF\u7528";
    }
  },
  vanCouponCell: {
    title: 'cupom',
    tips: 'Não disponível',
    count: function count(_count) {
      return _count + "\u5F20\u53EF\u7528";
    }
  },
  vanCouponList: {
    empty: 'Sem cupons',
    exchange: 'intercâmbio',
    close: 'Não use cupons',
    enable: 'Disponível',
    disabled: 'indisponível',
    placeholder: 'Por favor insira o código do cupom'
  },
  vanAddressEdit: {
    area: 'área',
    postal: 'Código postal',
    areaEmpty: 'por favor selecione a região',
    addressEmpty: 'Por favor, preencha o endereço detalhado',
    postalEmpty: 'Formato de código postal incorreto',
    defaultAddress: 'Defina como endereço de entrega padrão',
    telPlaceholder: 'Número do celular do consignatário',
    namePlaceholder: 'Nome do consignado',
    areaPlaceholder: 'Selecione a província / cidade / distrito'
  },
  vanAddressEditDetail: {
    label: 'Endereço',
    placeholder: 'Número da rua, número do andar do quarto e outras informações'
  },
  vanAddressList: {
    add: 'Adicionar endereço'
  }
};
